import { Plugins } from '@leverege/plugin';
import RolloverModel from './RolloverModel.js';
import RolloverEditor from "./RolloverEditor.js";
import RolloverTypeModel from './RolloverTypeModel.js';
import RolloverTypeEditor from "./RolloverTypeEditor.js";
import DetailListCard from "../shared/DetailListCard.js";
import { createDetailExportModel } from '../DetailExportModelCreator.js';
export default {
  install: opts => {
    Plugins.add('Model', {
      type: RolloverModel.TYPE,
      model: RolloverModel
    });
    Plugins.add('ModelEditor', {
      type: RolloverModel.TYPE,
      editor: RolloverEditor
    });
    Plugins.add('ExportModelCreator', {
      type: RolloverModel.TYPE,
      creator: createDetailExportModel
    });
    Plugins.add('Model', {
      type: RolloverTypeModel.TYPE,
      model: RolloverTypeModel
    });
    Plugins.add('ModelEditor', {
      type: RolloverTypeModel.TYPE,
      editor: RolloverTypeEditor
    });
    Plugins.add('RolloverCard', {
      type: 'detail.DetailList',
      card: DetailListCard
    });
  }
};